module.exports = __webpack_public_path__ + "assets/parenteses.85ba7064.svg";